export const en = {
  dataIterator: {
    rowsPerPageText: 'Records per page:',
    rowsPerPageAll: 'All',
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    nextPage: 'Next page',
    prevPage: 'Previous page',
  },
  dataTable: {
    rowsPerPageText: 'Records per page:',
  },
  login: {
    loginAccess: 'ACCESS TO YOUR SERVICES',
    username: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    submit: 'Submit',
    errors: {
      attemptError: 'You have tried to many times. \n Try it later',
      eUsernameInvalid: 'Invalid email',
      eUsernameRequired: 'Username is required',
      ePasswordRequired: 'Password is required',
      eUserPass: 'Invalid username or password',
    },
  },
  recovery: {
    notFound: 'PAGE NOT AVAILABLE OR EXPIRED',
    title: 'RECOVERY PASSWORD REQUEST',
    emailInput: 'Enter your email address',
    sendedRequest:
      'A request has been sended. Verify your email to continue the process',
    changePassword: 'NEW PASSWORD',
    newPassword: 'Enter your new password',
    passwordUpdated:
      'Your password has been updated. Log in with your new password.',
    login: 'Login',
    form: {
      email: 'Email',
      password: 'Passowrd',
      cPassword: 'Confirm password',
    },
    errors: {
      title: 'Error',
      main: 'AN ERROR OCCURRED, TRY IT LATER',
      eEmailInvalid: 'Email was not found, please try again.',
      eEmailRequired: 'Email is required',
      ePasswordRequired: 'Password is required',
      eConfirmPasswordRequired: 'Password confirmation is required',
      ePasswordsMatch: "The passwords don't match",
    },
    submit: 'Submit',
  },
  qr: {
    title: 'QR GENERATOR',
  },
  modals: {
    ok: 'Accept',
    cancel: 'Cancel',
    save: 'Save',
  },
  panel: {
    loading: 'Loading',
    home: 'Administration Panel',
    configuration: 'Configuration',
    levels: 'Levels',
    extraLevels: 'Extracurriculars',
    employees: 'Employees',
    students: 'Students',
    parents: 'Parents',
    devices: 'Devices',
    reports: 'Reports',
    rounds: 'Rounds',
    comunity: 'Comunity',
    statistics: 'Statistics',
    visor: 'Delivers',
    visor2: 'Delivers (BETA)',
    changingBranch: 'Changing branch',
    unsavedChangesTitle: 'Unsaved changes',
    unsavedChangesDescription:
      'You have unsaved changes.<br/> Do you wish to save the last changes?',
    consultCollaboratorQR: 'Check my QR',
    activityCentre: 'Activity centre',
    logOut: 'Logout',
    help: 'Help Center',
    helpC: 'Web tool where we share support material about Skolable',
    //Descriptions
    configDesc: 'Access your school settings',
    levelsDesc: 'Add and manage your school levels, grades and groups',
    extraLevelsDesc:
      'Manage the registers of students inside extracurricular levels',
    empDesc: 'Add and manage your school employees',
    stdDesc: 'Add and manage your school students',
    parDesc: 'Add and manage your school parents',
    devDesc: 'Add and manage staff devices of your school',
    repoDesc: 'Visualize and download daily reports of your students',
    rndDesc: 'Visualize facial recognition results and reports of your school',
    comunDesc:
      'Create and manage events, notices and permits for your school or personal reports to your parents students',
    statDesc: 'Visualize students delivery statistics of your school',
    visorDesc: 'Real time visualization of the delivery process of your school',
    visor2Desc:
      'Real time visualization of the delivery process of your school',
    helpcenter: 'Help Center',
    update: 'Updates',
    updateDesc: 'skolable updates',
    schedule: 'Collaborator schedules',
    scheduleDes: 'Manage employee schedules and visualize attendance reports',
    authorizations: 'Exit passes',
    authorizationsDesc:
      'View all the exit passes of the students who can leave the school alone.',
  },
  home: {
    unAuthorized: 'Unauthorized',
    inDevelopment: 'In development',
    title: 'Administration Panel',
  },
  activityCentre: {
    title: 'Activity center',
    alerts: 'Alerts',
    initialConfiguration: 'Initial configuration',
    doors: 'Doors',
    dDesc1: 'Add at least one door',
    levels: 'Levels',
    lDesc1: 'Add at least one level',
    lDesc2: 'Link at least one door to a level',
    lDesc3: 'Add at least one grade and group to a level',
    employee: 'Employees',
    eDesc1: 'Add at least an employee',
    students: 'Students',
    sDesc1: 'Add at least a student',
    sDesc2: 'Link at least a student with a parent',
    parents: 'Parents',
    pDesc1: 'Add at least a parent',
    pDesc2: 'Add at least a family QR code',
    pDesc3: 'Link at least one parent with a student',
    devices: 'Devices',
    devDesc1: 'Add at least one Ipad and Unique Device',
    tutorsUnlink: 'There are %d parents without students',
    studentsUnlink: 'There are %d students without parents',
  },
  visor: {
    search: 'Search',
    check_out: 'Check out',
    start_dismissal: 'Start dismissal',
    edit_groups: 'Edit groups',
    qr_assets_of_the_day: ' Active QR codes.',
    notification_interval: 'Notification interval',
    notification_sound: 'Notification Ringtones',
    start_dismissal: 'Start dismissal',
    groups: 'Groups',
    more_groups: 'more groups',
    total_students: 'Total number of students',
    requested: 'Requested',
    on_the_way: 'On the way',
    delivered: 'Handed over',
    updating_groups: 'Updating Groups',
    starting_dismissal: 'Starting Dismissal',
    dismissal_has_begun: 'Dismissal has begun',
    dismissal_time_is_ending: 'Dismissal time is ending',
    dismissal_time_has_ended: 'Dismissal time has ended',
    something_went_wrong: 'Oops! Something went wrong.',
    updated_groups: 'Updated Groups',
  },
  generic: {
    qr_suspend: {
      suspend_qr_title_one: 'Suspend QR',
      suspend_qr_description_one:
        "By suspending this user's QR it will remain invalid and cannot be used for school login until it is activated again.",
      suspend_qr_title_many: 'Suspend QRs',
      suspend_qr_description_many:
        "By suspending this user's QR it will remain invalid and cannot be used for school login until it is activated again.",
      reason:
        'This reason will be displayed when the user tries to log in and has their QR code suspended.',
    },
    modal_qr: {
      page_breaks_groups: "Download QR's without page breaks between groups.",
    },
    accept: 'Accept',
    cancel: 'Cancel',
    save: 'Save',
    download: 'Download',
    alert: 'Alert',
    close: 'Close',
    more_options: 'More options',
    options: 'Opciones',
    search: 'Search',
  },
  students: {
    students: 'Students',
    search: 'Search',
    delete_student: 'Delete student',
    delete_students: 'Delete students',
    options: 'Options',
    create_student: 'Create student',
    photo: 'Photo',
    first_name: 'First name',
    last_name: 'Last name',
    level: 'Level',
    group: 'Group',
    tutors: 'Tutors',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    qr_code: 'QR code',
    qr_status: 'QR code status',
    student_id: 'Student ID',
    download_students: 'Download students',
    download_tutors_and_students: 'Download tutors and students',
    import_students_and_tutors: 'Import students and tutors',
    records_per_page: 'Records per page',
    edit_student: 'Edit student',
    suspend_qr: 'Suspend QR',
    download_qr_s: "Download QR's",

    modal_student: {
      'name_(s)': 'Name (s)',
      last_name: 'Last name',
      level: 'Level',
      grade_and_group: 'Grade and group',
      student_id: 'Student ID',
      male: 'Male',
      female: 'Female',
      cancel: 'CANCEL',
      save: 'SAVE',
    },

    modal_qr: {
      indefinite: 'Indefinite',
      reason_to_suspend_the_qr: 'Enter the reason you wish to suspend the QR.',
      start_date: 'Start date',
      end_date: 'End date',
      cancel: 'CANCEL',
      suspend: 'SUSPEND',
    },

    modal_download_qr: {
      qr_download: 'Download QR Code',
      download_format: 'Choose the download format',
      qr_code_size: 'QR code size',
      qr_code_size_2: 'per page in letter size.',
      small: 'Small',
      large: 'Large',
      page_breaks_groups:
        'Download QR codes without page breaks between groups.',
      cancel: 'Cancel',
      file_name: 'Select the options to save your file name with',
      download_pdf: 'Download pdf',
      download_png: 'Download png',

      student_id: 'Student ID',
      first_name: 'First name',
      last_name: 'Last name',
      all_of_the_above: 'All of the above',
      role: 'Role',
    },

    table_parents: {
      save: 'Save',
      delete: 'Delete',
      photo: 'Photo',
      first_name: 'First name',
      last_name: 'Last name',
      e_mail: 'E-mail',
      create_tutor: 'Create tutor',
      linking_a_tutor: 'Linking a tutor',
    },

    tutor_modal: {
      create_tutor: 'Create tutor',
      edit_tutor: 'Edit tutor',
    },

    modal_link_tutor: {
      add_tutor_to_student: 'Add tutor to student',
      name_of_the_parent_or_tutor: 'Write the name of the parent or tutor',
      tutor_s_name: "Tutor's name",
      select_one_or_more_tutors: 'Select one or more tutors',
      cancel: 'CANCEL',
      save: 'SAVE',
    },

    table_exta: {
      level: 'Level',
      activity_grade: 'Activity/Grade',
      group: 'Group',
    },

    massive_upload: {
      steps: {
        upload_your_file: 'Upload file',
        content_verification: 'Content verification',
        detail: 'Detail',
        validate_data: 'Confirm information',
        finished: 'Finished',
      },

      step_1: {
        import_excel_file:
          'Upload students list excel file as shown in the example.',
        download: 'Download',
        drag_file_1: 'Drag your Excel file here',
        drag_file_2: ' OR ',
        drag_file_3: 'select',
        drag_file_4: 'select the file',
        update_levels: 'Updating levels, grades and groups',
        valid_file: 'Valid file',

        confirm_modal: {
          title: 'Confirmation',
          description: 'Do you want to send mail to new tutors?',
          btn: 'Ok',
        },
      },

      step_2: {
        table: {
          first_name: 'First name',
          last_name: 'Last name',
          gender: 'Gender',
          level: 'Level',
          grade: 'Grade',
          group: 'Group',
          student_id: 'Student ID',
          new_student_id: 'New student ID',
          parents: 'Parents',
          error: 'Error',
          records_per_page: 'Records per page',
        },
      },

      step_3: {
        table: {
          search: 'Search',
          status_top: 'Status',
          first_name: 'First name',
          last_name: 'Last name',
          gender: 'Gender',
          level: 'Level',
          grade: 'Grade',
          group: 'Group',
          student_id: 'Student ID',
          parents: 'Parents',
          error: 'Error',
          records_per_page: 'Records per page',
          status: 'Status',

          edit_modal: {
            edit_data: 'Edit information',
            first_name: 'First name',
            last_name: 'Last name',
            level: 'Level',
            grade_and_group: 'Grade and group',
            student_id: 'Student ID',
            new_student_id: 'New student ID',
            male: 'Male',
            female: 'Female',
            cancel: 'CANCEL',
            save: 'SAVE',
          },

          parent_detail: {
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email',
            edit: 'Edit',

            edit_parent_modal: {
              edit_tutor: 'Edit tutor',
              first_name: 'First name',
              last_name: 'Last name',
              email: 'Email',
              cancel: 'Cancel',
              save: 'Save',
            },
          },
        },

        modal_email_confirm: {
          title: 'Confirmation',
          description: 'Do you want to send mail to new tutors?',
        },

        modal: {
          title: 'Important',
          description:
            'Below is the list of students and the status of each one of them, verify the information before uploading.',
        },

        modal_upload_info: {
          import_students_and_tutors: 'Import students and tutors',
          following_data_will_be_imported:
            'The following data will be imported:',
          important: 'Important:',
          important_description:
            'Remember that data will be replaced with the new information and cannot be retrieved once the upload is complete.',
          cancel: 'Cancel',
          upload: 'Upload',
        },
      },

      step_4: {
        import_completed: 'Import completed',
        import_success:
          'The import was completed successfully, you can check the records in their corresponding sections.',
      },

      cancel: 'CANCEL',
      finish: 'Finish',
      download: 'Download',
      validate: 'Validate',
      upload: 'Upload',
    },
  },
  parents: {
    tutors: 'Tutors',
    search: 'Search',
    delete: 'Delete',
    delete_tutor: 'Delete tutor',
    send_code: 'Send code',
    clear_filter: 'Clear filter',
    options: 'Options',
    create_tutor: 'Create tutor',

    download_tutors: 'Download tutors',
    download_tutors_and_students: 'Download tutors and students',
    suspend_qr: 'Suspend QR',
    registered: 'Registered',
    not_registered: 'Not registered',
    edit_tutor: 'Edit tutor',
    records_per_page: 'Records per page',

    photo: 'Photo',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    tutored: 'Tutored',
    level: 'Level',
    group: 'Group',
    automobiles: 'Automobiles',
    drivers: 'Drivers',
    status: 'Status',
    last_login: 'Last Login',
    qr_status: 'QR code status',
    qr_code: 'QR code',
    clear_filter: 'Clear filter',

    edit_tutor_modal: {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      update: 'UPDATE',
      add_photo: 'Add photo',
      cancel: 'Cancel',
      save: 'Save',
    },

    table_tutors: {
      photo: 'Photo',
      first_name: 'First name',
      last_name: 'Last name',
      level: 'Level',
      group: 'Group',
      create_student: 'Create student',
      options: 'Options',
      students_to_be_linked: 'Select the students to be linked',
      add_student_to_tutor: 'Add student to tutor',
      edit_student: 'Edit student',
      search_student: 'Enter the name of the student',
      help_search_student:
        'Enter the name of the student to be linked with the tutor',
      select_the_students: 'Select the students to be linked',
      cancel: 'Cancel',
      save: 'Save',
    },

    drivers_table: {
      photo: 'Photo',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      status: 'Status',
      last_login: 'Last Login',
    },

    modal_qr: {
      qr_download: 'Download QR Code',
      download_format: 'Choose the download format',
      qr_code_size: 'QR code size',
      qr_code_size_2: 'per page in letter size.',
      small: 'Small',
      large: 'Large',
      page_breaks_groups:
        'Download QR codes without page breaks between groups.',
      cancel: 'Cancel',
      save: 'Save',
    },
  },
  employee: {
    search: 'Search',
    employees: 'Employees',
    photo: 'Photo',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    qr_code: 'QR code',
    qr_status: 'QR code status',
    role: 'Role',
    delete: 'Delete',
    edit_collaborator: 'Edit collaborator',
    options: 'Options',
    create_collaborator: 'Create collaborator',
    import_collaborators: 'Import collaborators',
    download_collaborators: 'Download collaborators',
    download_qr_s: "Download QR's",

    edit_employee_modal: {
      create_collaborator: 'Create collaborator',
      edit_collaborator: 'Edit collaborator',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      role: 'Role',
      add_photo: 'Add photo',
      update: 'Update',
      cancel: 'Cancel',
      save: 'Save',
    },

    modal_qr: {
      qr_download: 'Download QR Code',
    },
  },
  configuration: {
    configuration: 'Configuration',

    location_settings_title: 'LOCATION SETTINGS',
    payment_adjustments_title: 'PAYMENT ADJUSTMENTS',
    cell_phone_app_settings_title: 'CELL PHONE APP SETTINGS',
    main_school_settings_title: 'MAIN SCHOOL SETTINGS',
    permits_title: 'PERMITS',
    general_settings_title: 'GENERAL SETTINGS',

    save_changes: 'Save changes',
    add_door: 'Add door',
    download_doors: 'Download doors',
    cancel: 'CANCEL',
    save: 'SAVE',

    meters: 'meters',
    seconds: 'seconds',

    location_settings: {
      doors: 'Doors',
      location_settings: 'LOCATION SETTINGS',
      door_information: 'Door Information:',
      name: 'Name',
      reference_street: 'Reference Street',
      door_type: 'Door type',
      radial_distance: 'Radial distance.',
      meters: 'meters',
      select_door_color: 'Select door color (Optional)',
      edit_door: 'Edit Door',
      delete_door: 'Delete door',
      delete_door_description:
        'You are about to delete a door. Are you sure you wish to continue?',
      school_address: 'School address:',
      time_zone: 'Time zone:',
      change_school_location:
        'To change the location of the school, type the address in the search engine',
      search: 'Search',

      help: {
        title: 'Adding color to the door',
        description:
          "When a color is added to the door, it will be reflected on the student's cards in the web chek outs and in the Staff app. If the door color is not added or is removed, the color is not displayed on the cards in the web check outs, in Staff it will take the color of the statuses.",
      },
    },

    general_settings: {
      information: 'Information',
      update_logo: 'UPDATE LOGO',
      college_qr: 'College QR Code',
      name: 'Name',
      payment_adjustments_title: 'PAYMENT ADJUSTMENTS',
      profile_editing_by_tutors: "Tutors' Profile Editing",
      profile_editing_by_tutors_help:
        'Allows tutors to edit their profile information',
      student_editing_by_tutors: "Tutors' Student Editing",
      student_editing_by_tutors_help:
        "Allows tutors to edit their child's profile picture",
      institution_qr_code: 'Institution QR code',
      edit_image: 'Edit Image',
      add_image: 'Add Image',

      requests: {
        requests_title: 'Requests',
        range_of_time_to_apply_for_students:
          'Range of time to apply for students',
        specify: 'Specify',
        all_day: 'All day',

        requests_help_1:
          'Controls the time in which tutors can request their children:',
        requests_help_2: ': Tutors can request their children at any time.',
        requests_help_3:
          ': Tutors can only request their children within a specified time range',

        minutes_before_dismissal_time: 'minutes before dismissal time',
        minutes_after_dismissal_time: 'minutes after dismissal time',

        time_in_minutes_to_request_students_help_1_1:
          'Time in minutes to request students',
        time_in_minutes_to_request_students_help_1_2:
          'Maximum time to request students',
        time_in_minutes_to_request_students_help_2_1: 'BEFORE',
        time_in_minutes_to_request_students_help_2_2: 'AFTER',
        time_in_minutes_to_request_students_help_3: 'dismissal time.',
        time_in_minutes_to_request_students_help_4: 'Example 120 mins = 2hrs',

        time_to_request_again: 'Time to request again',
        time_to_request_again_help:
          'Set a certain time, to request again the student',
      },

      mail_servers: {
        mail_servers_title: 'Mail servers:',
        skolable_mail: 'Skolable Mail',
        skolable_mail_help:
          'Set up the email account that will be used to send welcome emails to tutors and collaborators once they are registered.',

        add_new_email: 'Add a new e-mail',
        user: 'User',
        email: 'Email',
        pasword: 'Pasword',
        port: 'Port',
        host: 'Host',
        protocol: 'Protocol',
        cancel: 'Cancel',
        accept: 'Accept',
      },

      restart_transactions: {
        restart_transactions_title: 'Restart transactions',
        restart_transactions_description_1:
          'Restart transactions that have been performed or are in process for the current day.',
        restart_transactions_description_2:
          'This process is destructive so you will not be able to recover the deleted information.',
        restart: 'RESTART',
      },

      students_requests_settings: {
        activate_gps_assistance_for_requests:
          'Activate GPS assistance for requests',
        activate_gps_assistance_for_requests_help:
          'GPS assistance allows requests to be made depending on the location of the device',
        activate_gps_assistance_for_requests_alert:
          "By deactivating the use of geolocation, all requests from today's students who are on wait will be accepted. Do you want to continue?",
        advanced_options: 'Advanced Options',
        scan_on_arrive: 'Request upon arrival',
        scan_on_arrive_help:
          'This option solicits for tutors to scan an institute QR code to be able to request students.',

        advanced_options_help:
          'advanced GPS settings, only for authorized user',
        maximum_waiting_time: 'Maximum waiting time',
        maximum_waiting_time_help:
          'Maximum waiting time to obtain a response from the satellite position',
        accuracy_range: 'Accuracy range',
        accuracy_range_help:
          'Sets a minimum accepted range for location response',
        attempts: 'attempts',
        number_of_attempts: 'Number of attempts',
        number_of_attempts_help:
          'Sets an accepted minimum number of attempts for a successful localization response',
      },

      school_days: {
        school_days_title: 'School Days',
        days: 'Days',
        school_days_help:
          'Select the school days on which your institution will allow student requests.',
      },

      delivery_verification: {
        delivery_verification_title: 'Delivery verification',
        minutes: 'minutes',
        notification_intervals_1: 'Notification intervals:',
        notification_intervals_help:
          'Controls the time interval at which the verification notification is displayed to the tutor',

        confirmation_waiting_time: 'Confirmation waiting time:',
        confirmation_waiting_time_help:
          'Set the amount of time the tutor has to confirm that his student is with him before automatically delivered"',
      },

      hierarchy_validation: {
        hierarchy_validation_title: 'Hierarchy validation',
        enable_similar_hierarchy_validation:
          'Enable similar hierarchy validation',
        hierarchy_validation_help:
          'The user can update and/or delete other users who have a role with an equal or lower hierarchy',
      },

      authorization_of_announcements: {
        announcement_authorization_title: 'Announcement Authorization',
        moderator: 'Announcement moderator',
        announcement_authorization_help:
          "Adds a level of security when the institute's authorization is required to publish announcement",
      },

      carpool_settings: {
        carpool_settings_title: 'Carpool Settings',
        activate_carpool_authorization: 'Activate carpool authorization',
        activate_carpool_authorization_help:
          'Adds a level of security by requiring authorization from the institute for the creation of carpools',

        minimum_of_students_per_round: 'Minimum of students per round',
        students: 'students',
        students_help:
          'Sets a minimum number of students required to create a round.',
      },
    },

    main_school_settings: {
      main_school_information: 'Main School information',

      name: 'Name',
      address: 'Address',
      phone_number: 'Phone number',
      description: 'Description',
      search: 'Search',
      school_address_1: 'School address',
      school_address_2:
        'To change the location of the school, type the address in the search engine',
    },

    cell_phone_app_settings: {
      mobile_device_app_preview: 'Mobile device app preview',
      mobile_device_app_side_menu: 'Mobile device app side menu',

      left_panel: {
        school_bulletin_board: 'School Bulletin Board',
        events: 'Events',
        performance: 'Performance',
        saved: 'Saved',
        surveys: 'Surveys',
        payments: 'Payments',
        qr: 'QR',
        set_up_notifications: 'Set up notifications',
        activate_guided_tour: 'Activate guided tour',
        settings: 'Settings',
        logout: 'Logout',
      },

      panel: {
        family: 'Family',
        third_parties: 'Third parties',
        notifications: 'Notifications',

        mobile_app_main_screen: 'Mobile app main screen',

        sections: 'Sections',

        pick_up: 'Pick up',
        community: 'Community',
        third_parties: 'Third parties',
        notifications: 'Notifications',
        carpool_deliveries: 'Carpool deliveries',
        students: 'Students',
        carpool: 'Carpool',
        vehicle: 'vehicle',
        profile: 'Profile',
        driver: 'Driver',
        qr_code_profile: 'QR code profile',
        notification_settings: 'Notification settings',
        payments: 'Payments',
        billing: 'Billing',
        surveys: 'Surveys',
        permits: 'Permits',
        authorizations: 'Exit passes',

        pick_up_help_title: 'Pick up',
        community_help_title: 'Community',
        third_parties_help_title: 'Third parties',
        notifications_help_title: 'Notifications',
        carpool_deliveries_help_title: 'Carpool deliveries',
        students_help_title: 'Students',
        carpool_help_title: 'Carpool',
        vehicle_help_title: 'vehicle',
        profile_help_title: 'Profile',
        driver_help_title: 'Driver',
        qr_code_profile_help_title: 'QR code profile',
        notification_settings_help_title: 'Notification settings',
        payments_help_title: 'Payment configuration',
        billing_help_title: 'Configuración de facturación',
        surveys_help_title: 'Survey configuration',

        pick_up_help:
          'Allows tutors to make requests for both their students and their rounds.',
        community_help:
          "Allows tutors to view notices, events or any communication issued in the institution or to the specific group of the tutor's student",
        third_parties_help:
          'Allows tutors to create special permissions for third parties to pick up their students at the institution.',
        notifications_help:
          'Permite a los tutores visualizar las notificaciones emitidas por el dispositivo',
        carpool_deliveries_help:
          'Allows tutors to make requests for their rounds.',
        students_help:
          "Allows tutors to view their students' information, as well as to edit their photograph, as long as the institute allows it.",
        carpool_help: 'Allows tutors to manage and create their rounds.',
        vehicle_help:
          'Allows tutors to manage information about the vehicles they use to pick up their children.',
        profile_help:
          'Permite a los tutores visualizar y gestionar su información personal, siempre y cuando el instituto lo permita',
        driver_help:
          'Allows tutors to manage the drivers they have to pick up their children from the institution.',
        qr_code_profile_help:
          'Allows tutors to view the personal QR code generated by the institute.',
        notification_settings_help:
          'Allows tutors to configure the notifications they wish to receive on their device.',
        payments_help: 'Allows tutors to make payments using their device.',
        billing_help: 'Configuración de facturación',
        surveys_help:
          'Allows access to the survey section published by the school.',
      },
    },
  },
  reports: {
    reports_title: 'Reports',
    capacity_report_title: 'Capacity report',
    capacity_report_details:
      'Registered capacity of students, collaborators, tutors and visitors.',
    check_in_and_check_out_report_title: 'Check-in and check-out report',
    check_in_and_check_out_report_details:
      'Historical check-in and check-out records of students, collaborators, tutors and visitors.',
    delivery_report_title: 'Delivery report',
    event_registration_title: 'Event reports',
    event_registration_details: 'Event registration',

    shared: {
      download_pdf: 'Download PDF',
      download_xlsx: 'Download XLSX',
      search: 'Search',
      more_options: 'More Options',
      clear_filters: 'Clear Filters',
    },

    capacity_report: {
      profile: 'Profile',
      all: 'all',
      level: 'Level',
      group: 'Group',
      role: 'Role',
      temperature: 'Temperature',
      initial: 'Initial',
      final: 'Final',

      total_capacity: 'Total Capacity',
      total_students: 'Total Students',
      total_number_of_collaborators: 'Total number of collaborators',
      total_number_of_tutors: 'Total number of tutors',
      total_visitors: 'Total Visitors',

      students: 'Students',
      collaborators: 'Collaborators',
      tutors: 'Tutors',
      visitors: 'Visitors',

      entry_date: 'Entry Date',
      entry_time: 'Entry Time',
      first_name: 'First Name',
      last_name: 'Last name',
      enrollment: 'Enrollment',
      gender: 'Gender',
      grade: 'Grade',
      visited: 'Visited',
    },

    check_in_and_check_out_report: {
      graphics: 'Graphics',
      profile: 'Profile',

      all: 'all',

      level: 'Level',
      group: 'Group',
      role: 'Role',
      temperature: 'Temperature',
      initial: 'Initial',
      final: 'Final',
      start_date: 'Start date',
      end_date: 'End date',

      total_students: 'Total Students',
      total_number_of_collaborators: 'Total number of collaborators',
      total_number_of_tutors: 'Total number of tutors',
      total_visitors: 'Total Visitors',

      first_name: 'First Name',
      last_name: 'Last name',
      entry_date: 'Entry Date',
      entry_time: 'Entry Time',
      out_date: 'Fecha Salida',
      out_time: 'Hora Salida',
      enrollment: 'Enrollment',
      grade: 'Grade',
      photo: 'Photo',
      gender: 'Gender',
      visited: 'Visited',

      students: 'Students',
      collaborators: 'Collaborators',
      tutors: 'Tutors',
      visitors: 'Visitors',
    },

    delivery_report: {
      graphics: 'Graphics',
      level: 'Level',
      group: 'Group',
      all: 'All',
      start_date: 'Start date',
      end_date: 'End date',

      first_name: 'First Name',
      last_name: 'Last name',
      enrollment: 'Enrollment',
      requested: 'Requested',
      called: 'Called',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      more_info: 'More Info',

      tutor_confirmation: 'Tutor confirmation',
      delivered_from_staff: 'Delivered from staff',
      check_out: 'Check out',
    },

    event_reports: {
      event_reports_title: 'Event reports',
      search: 'Type the name of the event to search for',
      event_title: 'Event title',
      generate_event_reports: 'Generate event reports',
      start: 'Start:',
      end: 'End:',
    },
  },
  levels: {
    levels_title: 'Levels',
    save_changes: 'Save changes',
    add_level: 'Add level',
    download_levels: 'Download Levels',
    general_information: 'GENERAL INFORMATION',
    doors: 'Doors',
    level_information: 'Level information',
    name: 'Name',
    abbreviation: 'Abbreviation',
    dismissal: 'Dismissal',
    extracurricular_level: 'Extracurricular level',
  },
  extracurricular: {
    extracurricular_title: 'Extracurricular',

    photo: 'Photo',
    first_name: 'First name',
    last_name: 'Last name',
    level: 'Level',
    group: 'Group',
    student_id: 'Student ID',

    add_students_modal: {
      add_students_title: 'Add students',
      search_student: "Student's name",
      search_help: 'Enter student name to link to level',
      level: 'Levels',
      groups: 'Groups',
      students: 'Students',
    },

    import_students_modal: {
      import_students_modal_title: 'Import students and extracurricular levels',

      upload_file: 'upload file',
      completed: 'Completed',
      error_corrections: 'Error corrections',
      drag_your_excel_file_here: 'Drag your Excel file here',
      or: 'OR',
      select: 'select',
      the_file: 'the file',
      import_your_students_excel_file_example:
        "Import your students' Excel file as shown in the example.",
      validate: 'Validate',
      student_id: 'Student ID',
      grade_level: 'Grade Level',
      activity: 'Activity',
      group: 'Group',
      error: 'Error',

      last_step_warn:
        'Some files could not be imported, download the file to verify the data.',
      warning: 'Warning',
    },
  },
  devices: {
    devices_title: 'Devices',
    ipad: 'IPAD',
    android_tablet: 'ANDROID TABLET',
    add_device: 'Add device',
    permissions: 'Permissions',
    access_control: 'Access control',
    exit_control: 'Exit control',
    cancel: 'CANCEL',
    save: 'SAVE',
    fixed_assistant: 'iPad device, fixed assistant',
    synchronized_device: 'Synchronized device',
    name_ipad: 'Name Ipad',
    permissions: 'Permissions',
    incoming_control: 'Incoming control',
    unpair: 'Unpair',
    linked_device: 'Linked device',
    klipy_devices: 'Klipy devices',
  },
  surveys: {
    surveys_title: 'Surveys',
    custom_survey: 'Custom survey',
    name: 'Name',
    frequency: 'Frequency',
    publication_date: 'Publication Date',
    status: 'Status',
    alert_responses: 'Alert Responses',

    completed: 'Completed',
    published: 'Published',

    delete_survey_title: 'Delete survey',
    delete_survey_description:
      'Are you sure you want to perform this action, this process is irreversible and you will not be able to recover the information?',

    make_survey_copy: 'Make survey copy',
    view_survey: 'View Survey',
    survey_details: 'Survey details',
    edit_survey: 'Edit survey',
    stop_survey: 'Stop survey',

    creator: 'Creator',
    frequency: 'Frequency',
    start_date: 'Start date',
    end_date: 'End date',

    last_name: 'Last name',
    level: 'Level',
    grade: 'Grade',
    group: 'Group',
    answers: 'Answers',
    with_alert: 'With alert',
    download: 'Download',
    registration: 'Registration',
    date_and_time: 'Date and time',

    question: 'Question',
    answers: 'Answers',
    alert: 'Alert',
    answered_by: 'Answered by',

    survey: 'Survey',
    questions: 'Questions',
    catalog: 'Catalog',
    audience: 'Audience',
    preview: 'Preview',

    create_survey_title: 'Create survey',
    edit_survey_title: 'Edit survey',
    create_survey: {
      survey_name: 'Survey name',
      select_periodicity: 'Select periodicity',
      only_once: 'ONLY ONCE',
      daily: 'DAILY',
      weekly: 'WEEKLY',
      monthly: 'MONTHLY',
      start_date: 'Start date',
      end_date: 'End Date',

      write_your_question: 'Write your question',
      select_the_type: 'Select the type',
      option: 'Option',
      simple: 'SIMPLE',
      multiple: 'MULTIPLE',
      open: 'OPEN',
      add_question: 'Add question',

      check_alert: 'Check the box of the answers that you consider as alert',

      institutional: 'Institutional',
      the_entire_institution_will_be_notified:
        'The entire institution will be notified',
      levels: 'Levels',
      added_levels: 'added levels',
      drag_levels: 'Drag Levels',
      groups: 'Groups',
      drag_groups: 'Drag Groups',
      added_groups: 'Added Groups',
      subgroups: 'Subgroups',
      added_subgroups: 'Added subgroups',
      drag_subgroups: 'Drag subgroups',
      collaborators: 'Collaborators',
      added_collaborators: 'added collaborators',
      drag_collaborators: 'Drag collaborators',
      students_a: 'Students',
      students_b: 'Students',
      added_students: 'Added Students',
      drag_students: 'Drag students',

      survey_name: 'Survey Name',
      periodicity: 'Periodicity',
      start_date: 'Start date',
      end_date: 'End date',
      vew_audience_list: 'Vew Audience list',
      audience: 'Audience',
      schedule_survey: 'Schedule survey',
      required_for_access: 'Required for access',
      notify_by_mail: 'Notify by mail',
      view_questions: 'View Questions',

      check_covid: 'Check the box for answers you consider key responses.',
      covid_question: 'Does your child have the following symptoms?',
      multiple: 'MULTIPLE',
      dry_cough: 'Dry cough',
      headache: 'Headache',
      difficulty_breathing: 'Difficulty breathing',
      general_discomfort: 'General discomfort',
      sore_throat: 'Sore throat',
      temperature: 'Temperature',
      no_symptoms: 'No symptoms',
    },
  },
}
